import {Component, Inject, Input, Optional, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {AvisHelper} from '../avis-helper';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StateEnum, WinpayeService} from '../../../common/services';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Winpaye} from '../../../common/services/winpaye/winpaye.model';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';

/**
 * Avis SBTCP
 * Code Winpaye
 */
@Component({
  selector: 'app-avis-sbtcp',
  templateUrl: './avis-sbtcp.component.html',
  styleUrls: ['./avis-sbtcp.component.scss']
})
export class AvisSbtcpComponent extends AvisHelper {
  @Input() winpaye: Winpaye = null;
  winpayeCodes: Winpaye[] = [];
  loadingWinpaye = false;
  subSink = new SubSink();
  constructor(public winpayeSvc: WinpayeService,
              private dossierSvc: DarDossiersService,
              private router: Router, private route: ActivatedRoute,
              public formBuilder: UntypedFormBuilder,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() public dialogRef: MatDialogRef<AvisSbtcpComponent>) {
    super(formBuilder);
    this.avisConcerned = StateEnum.sbtcp;
    this.initAvisFormGroup();
    this._initWinpaye();
    this._winpayeCodes();
  }

  private _initWinpaye() {
    this.avisFormGroup.controls['winpaye'].valueChanges.subscribe((value) => {
      const emitData = this.winpayeCodes.find((_item) => _item.label === value);
      this.winpayeUpdated.emit(emitData);
    });
  }

  private _winpayeCodes() {
    this.loadingWinpaye = true;
    this.subSink.sink = this.winpayeSvc
      .listAllItems()
      .pipe(finalize(() => this.loadingWinpaye = false))
      .subscribe((_winpay_codes) => {
        this.winpayeCodes = _winpay_codes.list;
        this._winpayeCodeSelectedWithDarLoad();
    });
  }

  private _winpayeCodeSelectedWithDarLoad() {
    const id = this.route.snapshot.params['id'];
    if (id && id !== '0') {
      this.subSink.sink = this.dossierSvc.get(id).subscribe((_dossier) => {
        if (_dossier.winpaye_sbtcp_obj !== null) {
          this.setWinpaye(_dossier.winpaye_sbtcp_obj);
        }
      });
    }
  }

  setWinpaye(winpaye: Winpaye) {
    this.avisFormGroup.patchValue({winpaye: winpaye.label});
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.winpaye?.currentValue !== null && changes?.winpaye?.isFirstChange()) {
      this.setWinpaye(changes.winpaye.currentValue);
    }
    super.ngOnChanges(changes);
  }
}
